import React from 'react';

import './PrintDisclaimer.css';

const PrintDisclaimer = () => (
  <div className='PrintDisclaimer'>

    <small>
        © Copyright The New Zealand Institute for Plant and Food Research Limited and the
        Ministry of Health (New Zealand) on behalf of the Crown, 2018. All rights reserved.
        The use of any of the information on this page and any search results is governed
        by the Terms of Use. By accessing and viewing this page or using any of the
        information including any search results you agree that you have read and
        accepted such Terms of Use.
    </small>
  </div>
);

export default PrintDisclaimer;



// WEBPACK FOOTER //
// ./src/components/presentation/Print/PrintDisclaimer.js